export const isRedemptionOnCurrentDevice = () => true;
